import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  billNo: "",
  party: null,
  staff: null,
  name: "",
  branch: null,
  date: dayjs().format(),
  note: "",
  orderNo: 0,
  id: null,
  total: 0,
  discPerc: 0,
  discPercAmt: 0,
  discAmt: 0,
  taxPerc: 0,
  taxAmt: 0,
  otherChg: 0,
  netTotal: 0,
  receiptAmt: 0,
  cashP: "",
  receiptType: "",
  bankName: "",
  totalQty: 0,
  delivery_days:0,
  balance: 0,
  deliveryDate: dayjs().format(),
};

const quotationDataSlice = createSlice({
  name: "quotationMaster",
  initialState,
  reducers: {
    // Update multiple fields dynamically using Object.assign
    UPDATE_QUOTATION_HEAD(state, action) {
      Object.assign(state, action.payload);
    },

    // Reset state to its initial values using Object.assign
    RESET_QUOTATION_HEAD(state) {
      Object.assign(state, initialState);
    },
  },
});

export const { UPDATE_QUOTATION_HEAD, RESET_QUOTATION_HEAD } = quotationDataSlice.actions;

export default quotationDataSlice.reducer;
